import { useVisitStore } from "@/store/visit";
import { loadLanguage, setVisitUid, VISIT_UID_KEY } from "@/utils/storage";
import { getCookie } from "@/utils/cookies";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";
import { useLandingStore } from "@/store/landing.ts";
import { appendPreloadImage } from "@/utils/appendPreloadImage.ts";
import { getFreeareaVideoPoster } from "@/utils/mediaHelper.ts";
import { useCustomPageStore } from "@/store/customPage.ts";
import { changeLanguage } from "@/i18n.ts";
import { CustomPage } from "@/interfaces/Pages/CustomPage.ts";
import { Visit } from "@/interfaces/Visit.ts";

export default async ({ to, pinia }: MiddlewareInterface) => {
  const visitCookie = getCookie(VISIT_UID_KEY);

  if (visitCookie) {
    setVisitUid(visitCookie);
  }

  const visitStore = useVisitStore(pinia);

  let visit = visitStore.getVisit;

  if (visit) {
    return;
  }

  const lang = (loadLanguage() || document.documentElement.getAttribute("lang") || "en") as "en" | "de" | "fr";
  await visitStore.trackVisit(lang);
  visit = visitStore.getVisit as Visit;

  if (visit.new) {
    await changeLanguage(visit.lang);
  }

  if (visit.landing) {
    const landing = visit.landing;
    const thumb = visit.landing.hero_videos?.[0]?.thumb;

    if (thumb) {
      appendPreloadImage(getFreeareaVideoPoster(thumb), `landing-hero-poster-preload-${landing.id}`);
    }

    if (to.name === "CustomPage") {
      const page = { type: "landing", landing } as CustomPage;
      useCustomPageStore(pinia).addCustomPage(to.path, page, lang);
    } else {
      useLandingStore(pinia).setLandingPage(landing);
    }
  }
};
